import { cilMenu, cilPencil, cilX } from '@coreui/icons';
export const icons = Object.assign({
  cilMenu,
  cilPencil,
  cilX,
});
